module.exports = __webpack_public_path__ + "img/jaguar.80347bb1.png";